import { CircleAlert, CircleCheck, Info, TriangleAlert } from 'lucide-react';
import type { ReactNode } from 'react';
import styles from './Alert.module.css';

interface AlertProps {
  kind?: 'error' | 'info' | 'success' | 'warning';
  title?: string;
  children: ReactNode;
}

const ICONS = { error: CircleAlert, info: Info, success: CircleCheck, warning: TriangleAlert };

export function Alert({ kind = 'info', title, children }: AlertProps) {
  const Icon = ICONS[kind];
  return (
    <div className={`${styles.alert} ${styles[kind]}`} role={kind === 'error' ? 'alert' : undefined}>
      <Icon aria-hidden="true" className={styles.icon} />
      <div className={styles.content}>
        {title && <p className={styles.title}>{title}</p>}
        <div>{children}</div>
      </div>
    </div>
  );
}
